import {
  Drawer,
  DatePicker,
  TimePicker,
  PageHeader,
  Tag,
  Button,
  Comment,
  Avatar,
} from "antd";
import moment from "moment";
import { useState } from "react";
import { useMutation } from "react-query";
import axiosInstance from "../../config/axios-instance";
import avatar_placeholder from "../../img/avatar_placeholder.jpg";
import company_placeholder from "../../img/company_placeholder.png";
import { MyNotif } from "../NotifIcons/NotifIcons";

moment.defineLocale("en", {
  week: {
    dow: 1,
  },
});

export default function ConfirmDrawer({
  visible,
  onClose,
  meet,
  setVisible,
  refetch,
}: any) {
  const [data, setData] = useState(meet.start);

  const genStatus = (status: any) => {
    switch (status) {
      case "new":
        return {
          text: "New",
          color: "blue",
        };
      case "waiting":
        return {
          text: "Pending",
          color: "orange",
        };
      case "accepted":
        return {
          text: "Confirmed",
          color: "green",
        };
      default:
        return {
          text: "Cancelled",
          color: "red",
        };
    }
  };

  const rescheduleMeeting = async (type: string) => {
    let token = localStorage.getItem("token");
    if (type === "cancel") {
      await axiosInstance({
        method: "delete",
        url: `/admin/bookings/${meet.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      await axiosInstance({
        method: "post",
        url: `/admin/bookings/${meet.id}`,
        data: {
          status: "waiting",
          date: data,
          client_id: meet.details.client_id,
          _method: "patch",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    await MyNotif(
      type === "cancel"
        ? "Meeting cancelled successfully."
        : "Meeting rescheduled!",
      "success"
    );
    setVisible(false);
    refetch();
    // return response.data;
  };

  const {
    mutate: mutateUpdateBooking,
    isLoading: updateLoading,
    variables,
  } = useMutation((type: string) => rescheduleMeeting(type));
  return (
    <Drawer
      placement={"right"}
      closable={false}
      onClose={onClose}
      visible={visible}
      key={"right"}
      width="400"
      className="booking-drawer"
    >
      <div className="left-calendar-container">
        <h1 className="h1-blue-hj" style={{ marginTop: "20px" }}>
          Meeting details
        </h1>
        <PageHeader
          title={meet.subject}
          className="site-page-header p-0 my-5"
          tags={
            <Tag color={genStatus(meet.status).color}>
              {genStatus(meet.status).text}
            </Tag>
          }
          avatar={{
            src: meet.company
              ? process.env.REACT_APP_STORAGE_URL + meet.company.logo
              : company_placeholder,
          }}
        >
          <Comment
            className="meeting_notes border rounded pl-2 bg-white"
            author={<a>{meet.client.name}</a>}
            avatar={
              <Avatar
                shape="square"
                src={
                  meet.client.logo
                    ? process.env.REACT_APP_STORAGE_URL + meet.client.logo
                    : avatar_placeholder
                }
                alt={meet.client.name}
              />
            }
            content={<p>{meet.notes}</p>}
          />
        </PageHeader>
        <h3 className="h2-blue-hj">Select Date</h3>
        <DatePicker
          defaultValue={moment(meet.start)}
          showToday={false}
          disabledDate={function disabledDate(current: any) {
            // Can not select days before today and today
            return (
              (current && current <= moment().subtract(1, "d").endOf("day")) ||
              ["Saturday", "Sunday"].find(
                (date) => date === moment(current).format("dddd")
              )
            );
          }}
          onChange={(x: any) =>
            setData(
              moment(x)
                .set({
                  hour: moment(data).get("hour"),
                  minute: moment(data).get("minute"),
                  second: moment(data).get("second"),
                })
                .format()
            )
          }
          style={{ width: "100%" }}
        />
        <h3 className="h2-blue-hj">Select Meeting Hour</h3>
        <TimePicker
          onChange={(x: any) =>
            setData(
              moment(data)
                .set({
                  hour: x.get("hour"),
                  minute: x.get("minute"),
                  second: x.get("second"),
                })
                .format()
            )
          }
          style={{ width: "100%" }}
          defaultValue={moment(meet.start).utc()}
          showSecond={false}
          disabledHours={() => [
            0, 1, 2, 3, 4, 5, 6, 7, 17, 18, 19, 20, 21, 22, 23,
          ]}
          hideDisabledOptions
          minuteStep={15}
        />
        <Button
          // type="button"
          disabled={variables === "cancel"}
          className="reschedule-btn-drawer discard w-100 mt-4 my-3"
          onClick={() => mutateUpdateBooking("reschedule")}
          loading={variables === "reschedule" && updateLoading}
        >
          {variables === "reschedule" && updateLoading
            ? "Rescheduling..."
            : "Reschedule"}
        </Button>
        <Button
          type="link"
          className="d-flex justify-content-center mx-auto"
          onClick={() => mutateUpdateBooking("cancel")}
        >
          {variables === "cancel" && updateLoading
            ? "Cancelling..."
            : "Cancel Meeting"}
        </Button>
      </div>
    </Drawer>
  );
}
